module.exports = __webpack_public_path__ + "media/images/flags/4x3/vgb-37b510b2f9de3b2f1570bd772b5e7111.svg";